// custom typefaces
import React from "react"
import "typeface-montserrat"
import "typeface-merriweather"
import "./src/styles/global.scss"
